import { render, staticRenderFns } from "./serviceForm.vue?vue&type=template&id=d9bc3ca2&"
import script from "./serviceForm.vue?vue&type=script&lang=js&"
export * from "./serviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports